/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListCars200ResponseLinks
 */
export interface ListCars200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof ListCars200ResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof ListCars200ResponseLinks
     */
    last?: string;
    /**
     * 
     * @type {string}
     * @memberof ListCars200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListCars200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the ListCars200ResponseLinks interface.
 */
export function instanceOfListCars200ResponseLinks(value: object): value is ListCars200ResponseLinks {
    return true;
}

export function ListCars200ResponseLinksFromJSON(json: any): ListCars200ResponseLinks {
    return ListCars200ResponseLinksFromJSONTyped(json, false);
}

export function ListCars200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCars200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function ListCars200ResponseLinksToJSON(json: any): ListCars200ResponseLinks {
    return ListCars200ResponseLinksToJSONTyped(json, false);
}

export function ListCars200ResponseLinksToJSONTyped(value?: ListCars200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

